import React from 'react';

import RotateLeftIcon from '@mui/icons-material/RotateLeft';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const RestartActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <RotateLeftIcon />
    </BaseActionButton>
  );
};

export default RestartActionButton;
